function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

import './InitialScreen.scss';
import startAddBuildingWizardFlow from '../AddBuildingWizard/flow';
import appFeatures from 'effective-features!';

var BuildingsListCtrl = function BuildingsListCtrl($injector, $state, StateUtils, httpSettings, spreadsheetProcessorConfig, ModalService, $filter) {
    var _this = this;

    _classCallCheck(this, BuildingsListCtrl);

    this.$injector = $injector;
    this.$state = $state;
    this.model = StateUtils.activeDataForState(true).model;
    this.jobID = this.model.quoteID ? this.model.quoteID.value : this.model.jobID.value;
    this.ModalService = ModalService;
    this.$filter = $filter;

    var xCenterDownloadURI = httpSettings.serviceBaseURLs.pc;
    this.templateDownloadEndpointURL = xCenterDownloadURI + spreadsheetProcessorConfig.downloadTemplateURL;
    this.templateUploadEndpointURL = spreadsheetProcessorConfig.uploadTemplateURL;
    this.spreadsheetProcessorResult = this.$state.params.spreadsheetProcessorResult;
    this.spreadsheetProcessorEnabled = appFeatures.spreadsheetprocessor && appFeatures.spreadsheetprocessor.enabled;

    this.locations = this.model.lobData.commercialProperty.coverables.locations.value;
    var hasBuildings = this.locations.some(function (loc) {
        return loc.buildings && loc.buildings.length > 0;
    });

    var isSpreadsheetStatusFail = function isSpreadsheetStatusFail() {
        return ['fail-processing', 'fail-empty', 'fail-unchanged'].includes(_this.spreadsheetProcessorResult.status);
    };

    if (hasBuildings || this.spreadsheetProcessorResult != null && !isSpreadsheetStatusFail) {
        $state.go('cpBuildingWizardBuildingsList', { spreadsheetProcessorResult: this.spreadsheetProcessorResult });
    }

    if (this.spreadsheetProcessorResult) {
        this.$state.params.spreadsheetProcessorResult = undefined;
    }

    this.manualAddBuilding = function () {
        startAddBuildingWizardFlow(_this.$injector);
    };

    this.spreadsheetProcessor = function () {
        _this.$state.go('cpBuildingWizardSpreadsheetScreen', {
            manualAddBuildingDelegator: _this.manualAddBuilding,
            callbackState: 'cpBuildingWizardInitialScreen'
        });
    };
};

BuildingsListCtrl.$inject = ['$injector', '$state', 'StateUtils', 'httpSettings', 'qnb.spreadsheetProcessorConfig', 'ModalService', '$filter'];

export default BuildingsListCtrl;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gw-portals-cp-components-angular/buildingsWizard/InitialScreen/InitialScreen.js
// module id = 312
// module chunks = 0